import React from 'react';
import * as XLSX from 'xlsx';
import { useClasseContext } from '../../context/ClasseContext';
import { Download } from 'lucide-react';

const TemplateImportEcoleRattachement = () => {
  const { classeNom } = useClasseContext();

  const handleDownload = () => {
    const headers = ['Nom', 'Prénom', 'Classe' , "Etab. d'origine"];
    const exampleData = ['DUPONT', 'Benoit', classeNom || '602' , '9745421B - Ecole test - Saint-Andre'];

    const worksheetData = [headers, exampleData];
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, '23EVA6_mathématiques');

    XLSX.writeFile(workbook, 'TemplateImportEcoleRattachement.xlsx');
  };

  return (
    <div className="text-center">
      <button
        onClick={handleDownload}
        className="inline-flex items-center gap-2 text-sm text-blue-600 hover:text-blue-700 transition-colors group"
      >
        <Download size={16} className="group-hover:-translate-y-0.5 transition-transform" />
        <span>Télécharger le modèle Excel</span>
      </button>
    </div>
  );
};

export default TemplateImportEcoleRattachement;
